import Vue from 'vue'
import Vuex from 'vuex'
import { userInfo } from '@/api'
import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 0 无状态 1 待验证 5 已登录 9 未登录
    user_status: 0,
    user: null,
    token: '',
    app_key: '',
  },
  mutations: {
    INIT_TOKEN: (state, token) => {
      state.token = token
    },
    INIT_USER: (state, user) => {
      state.user_status = 5
      state.user = user
    },
    UPDATE_STATE: (state, user_status) => {
      state.user_status = user_status
    },
    RESET_STATE: (state) => {
      state.user = null
      state.user_status = 9
    },
    UPDATE_FRIENDCODE: (state, fc) => {
      if (state.user && 'friendcode' in state.user) {
        state.user.friendcode = fc;
      }
    }
  },
  actions: {
    initToken({ commit }, token) {
      setToken(token)
      commit('INIT_TOKEN', token)
    },
    syncUser({ commit, state }) {
      commit('UPDATE_STATE', 1);
      return new Promise((resolve, reject) => {
        userInfo().then(response => {
          const { data } = response
          if (!data) {
            return reject('获取登录信息失败')
          }
          commit('INIT_USER', data)
          resolve(data)
        }).catch(error => {
          commit('RESET_STATE');
          reject(error)
        })
      })
    },
    // remove token
    resetToken({ commit }) {
      return new Promise(resolve => {
        removeToken() // must remove  token  first
        commit('RESET_STATE')
        resolve()
      })
    }
  },
  modules: {
  }
})
